import useSelector from "./useSelector";

/**
 * Возвращает внутренние рамки устройства
 * @returns {Insets}
 */
const useInsets = () => useSelector((state) => state.config.insets);

export default useInsets;
